// extracted by mini-css-extract-plugin
module.exports = {"loginContain":"login-page_loginContain__12JNd","spinContain":"login-page_spinContain__2D1am","login":"login-page_login__1dYwX"};